import React from 'react';
import { Container } from 'reactstrap';
import SkeletonElement from '../../../../components/skeletons/SkeletonElement';

const CheckoutHeaderSkeleton = () => (
  <div className="header checkout-header sticky-top bg-white">
    <Container>
      <div className="d-flex justify-content-center align-items-center py-2 py-md-4 position-relative">
        <div className="d-flex align-items-center position-absolute start-0 w-25">
          <SkeletonElement type="label-short w-50" />
        </div>
        <div className="text-end w-25">
          <SkeletonElement type="button" className="w-100" />
        </div>
      </div>
    </Container>
  </div>
);

export default CheckoutHeaderSkeleton;
